<iui-modal-content>
    <div class="notification-layout">
        <!-- Icon -->
        <img class="alert-icon" src="/assets/images/AlertIconFacelift.svg" alt="alert icon">

        <div class="notification-content">
            <div class="text-content">
                <span class="notification-title">{{ 'IOSimPlus.ModalTitle' | translate }}</span>
                <span class="notification-message">{{ data.warningContent | translate }}</span>
            </div>
            <div class="notification-actions">
                <button id="btn-close" type="button" class="dialog-btn" (click)="close()">
                    {{ 'IOSimPlus.CloseButton' | translate }}
                </button>
                <button id="retry-btn" *ngIf="data.isRetryable" type="button" class="dialog-btn" (click)="retry()">
                    {{ 'IOSimPlus.RetryButton' | translate }}
                </button>
            </div>
        </div>
    </div>
</iui-modal-content>
